
import { defineComponent } from '@nuxtjs/composition-api';
import CompanyCard from './CompanyCard.vue';

export default defineComponent({
  components: {
    CompanyCard,
  },
  props: {
    companies: {
      type: Array,
      default: null,
    },
  },
});
